<div class="flex flex-col">
	<div class="w-full items-start mt-s text-center">
		<beyond-online-headline
			class="my-m"
			[headline]="popUpConfig.data?.headline || ''"
			size="s"
		></beyond-online-headline>
	</div>
	<div>
		<ul>
			<li
				*ngFor="let setting of countrySpecificSettings"
				beyond-online-text
				class="mt-s flex justify-between space-x-m border-b border-separator pb-s w-full"
			>
				<div>
					<span class="font-bold">{{ setting.name }}</span> ({{ setting.settingType }})
				</div>
				<input
					*ngIf="setting.settingType !== 'Boolean'; else booleanInput"
					[value]="setting.value"
					(change)="editSetting(setting, $any($event.target).value)"
					beyondInput
				/>
				<ng-template #booleanInput>
					<input
						type="checkbox"
						[checked]="setting.value === 'true'"
						(change)="editSetting(setting, setting.value === 'true' ? 'false' : 'true')"
					/>
				</ng-template>
			</li>
		</ul>
		<button
			beyond-online-button
			label="Save"
			class="w-full flex justify-center my-m"
			(click)="saveMockSettings()"
		></button>
	</div>
</div>
